<div
  class="fz-game-tags"
  [ngClass]="{
    'fz-game-tags__open': visible()
  }"
>
  <div *ngIf="tags && tags.length > 0" class="fz-game-tags__root">
    <!-- print first value -->
    <div *ngIf="tags.length > 0" class="fz-game-tags__tag">
      <img
        src="{{ assetUrl }}/shared/img/tournaments/tournament_types/{{
          tags[0] ? tags[0].toLowerCase().replace(' ', '_') : ''
        }}.svg"
        alt="Tournament tags"
      />
      <span>{{ tags[0] }}</span>
    </div>
    <div
      class="fz-game-tags__tag_icons touchable-area"
      (click)="toggle($event)"
    >
      <span
        *ngFor="let tag of tags.slice(1).reverse()"
        class="fz-game-tags__tag_icons__icon"
      >
        <img
          src="{{ assetUrl }}/shared/img/tournaments/tournament_types/{{
            tag ? tag.toLowerCase().replace(' ', '_') : ''
          }}.svg"
          [alt]="tag"
          [matTooltip]="tag"
        />
      </span>
    </div>
  </div>
</div>
